import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export function CompanyLogo({ companyId, refreshKey, className, fallback = null }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let active = true;
    let created;
    if (!companyId) { setUrl(null); return; }
    api.get(`/companies/${companyId}/logo`, { responseType: "blob" })
      .then((r) => { if (!active) return; created = URL.createObjectURL(r.data); setUrl(created); })
      .catch(() => { if (active) setUrl(null); });
    return () => { active = false; if (created) URL.revokeObjectURL(created); };
  }, [companyId, refreshKey]);

  if (!url) return fallback;
  return <img src={url} alt="Firma logosu" className={className} />;
}

export default CompanyLogo;
